import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ntxAPI } from '../../API/axiosNeatex';

export const AddRequest = createAsyncThunk('AmeRequest/AddRequest', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.post('AmeRequest/AddRequest', item);
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error);
  }
});

export const GetRequestList = createAsyncThunk('AmeRequest/GetRequestList', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    // const data = await getData("AmeRequest/GetRequestList" );
    const { data } = await ntxAPI.get('AmeRequest/GetRequestList');
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error);
  }
});

export const GetTransactionHistoryWithValueById = createAsyncThunk(
  'AmeRequest/GetTransactionHistoryWithValueById',
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(
        `AmeRequest/GetTransactionHistoryWithValueById?TransactionHistoryId=${id}`
      );
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const ActionRequest = createAsyncThunk(
  'AmeRequest/ActionRequest',
  async (item, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    console.log(JSON.stringify(item));
    debugger;
    try {
      const { data } = await ntxAPI.post('AmeRequest/ActionRequest', item);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const GetMyRequest = createAsyncThunk('AmeRequest/GetMyRequest', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    // const data = await getData("AmeRequest/GetMyRequests" );
    const { data } = await ntxAPI.get('AmeRequest/GetMyRequests');
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error);
  }
});

export const GetRequestListByFilter = createAsyncThunk(
  'AmeRequest/GetRequestListByFilter',
  async (bodyFilter, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post('AmeRequest/GetRequestListByFeltr', bodyFilter);
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

// نماذج الطلبات مع الصلاحيات
export const GetDynamicFormAme = createAsyncThunk(
  'AmeRequest/GetDynamicFormAme',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('AmeRequest/GetDynamicFormList');
      return data?.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

//~~~ طباعة الخطـــاب
export const letterPrint = createAsyncThunk(
  'AmeRequest/letterPrint',
  async (AmeTransectionHistoryId, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post(
        `Reports/LetterPrint?AmeTransectionHistoryId=${AmeTransectionHistoryId}`
      );
      return data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  RequestList: [],
  loadingViewRequest: false,
  loading: false,
  error: null,
  //~~~~
  TransactionHistoryWithValueList: [],
  loading2: false,
  error2: null,
  //~~~~
  MyRequestList: [],
  loadingGetMyRequest: false,
  errorGetMyRequest: null,
  //~~~~
  DynamicFormAme: [],
  loadingDynamicFormAme: false,
  errorDynamicFormAme: null,
};

const AmeRequestSlice = createSlice({
  name: 'AmeRequest',
  initialState,
  reducers: {
    cleanTransactionHistoryList: (state) => {
      state.TransactionHistoryWithValueList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Request list
      .addCase(GetRequestList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetRequestList.fulfilled, (state, action) => {
        state.loading = false;
        state.RequestList = action.payload;
      })
      .addCase(GetRequestList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get MyRequest list
      .addCase(GetMyRequest.pending, (state) => {
        state.loadingGetMyRequest = true;
        state.errorGetMyRequest = null;
      })
      .addCase(GetMyRequest.fulfilled, (state, action) => {
        state.loadingGetMyRequest = false;
        state.MyRequestList = action.payload;
      })
      .addCase(GetMyRequest.rejected, (state, action) => {
        state.loadingGetMyRequest = false;
        state.errorGetMyRequest = action.payload;
      })

      // Get Transaction History With Value List
      .addCase(GetTransactionHistoryWithValueById.pending, (state) => {
        state.loading2 = true;
        state.error2 = null;
        state.TransactionHistoryWithValueList = [];
      })
      .addCase(GetTransactionHistoryWithValueById.fulfilled, (state, action) => {
        state.loading2 = false;
        state.TransactionHistoryWithValueList = action.payload;
      })
      .addCase(GetTransactionHistoryWithValueById.rejected, (state, action) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })

      // Add Request
      .addCase(AddRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.RequestList.push(action.payload);
      })
      .addCase(AddRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Dynamic Form Ame
      .addCase(GetDynamicFormAme.pending, (state) => {
        state.loadingDynamicFormAme = true;
        state.DynamicFormAme = null;
        state.DynamicFormAme = [];
      })
      .addCase(GetDynamicFormAme.fulfilled, (state, action) => {
        state.loadingDynamicFormAme = false;
        state.DynamicFormAme = action.payload;
      })
      .addCase(GetDynamicFormAme.rejected, (state, action) => {
        state.loadingDynamicFormAme = false;
        state.errorDynamicFormAme = action.payload;
      });
  },
});

export const { cleanTransactionHistoryList } = AmeRequestSlice.actions;

export default AmeRequestSlice.reducer;
